import React from 'react';
import Navigation from './Navigation';
import { theme } from './theme';
import { ThemeProvider } from 'styled-components';
import { SideNavProvider } from './contexts';

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <SideNavProvider>
                < Navigation />
            </SideNavProvider>
        </ThemeProvider>
    );
};

export default App;
